import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

window.initSentry = (environment) => {
  if (environment === "development") {
    return;
  }

  Sentry.init({
    dsn: 'https://b4c0615827744d28bec2745a9dbc3855@o127091.ingest.sentry.io/6107339',
    integrations: [new Integrations.BrowserTracing()],
    environment,
    tracesSampleRate: environment === "production" ? 0.2 : 1.0,
  });
};
